export default __webpack_public_path__ + "static/media/583.8f2b075d.png";